if (!customElements.get('os-video-embed')) {
  class OsVideoEmbed extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.button?.addEventListener('click', this.#load, { once: true });
    }

    #load = () => {
      const iframe = document.createElement('iframe');
      iframe.src = this.dataset.embedUrl;
      iframe.title = this.dataset.title || 'Video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      this.button.replaceWith(iframe);
      iframe.focus();
    };
  }

  customElements.define('os-video-embed', OsVideoEmbed);
}
